import React from "react";
import { Container, Row, Col } from "reactstrap";

/**
 * Replace placeholder paths with your logos, e.g.:
 * require("assets/images/supported/partner-a.png")
 */
const logos = [
  { src: require("assets/images/IMG_3376.png"), alt: "Supported by — logo 2" },
  // { src: require("assets/images/IMG_3375.png"), alt: "Supported by — logo 1" },
];

function SupportedBy() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  return (
    <div
      className="section py-4"
      style={{
        background: "#000",
        borderTop: "1px solid rgba(255, 180, 31, 0.15)",
        borderBottom: "1px solid rgba(255, 180, 31, 0.15)",
      }}
    >
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col xs={12} className="text-center mb-4 mb-md-0">
            <p
              className="text-white mb-0"
              style={{
                fontSize: size ? "1.2rem" : "1rem",
                fontWeight: "600",
                letterSpacing: "0.35em",
                textTransform: "uppercase",
                color: "#ccb63a",
              }}
            >
              UNDER THE AUSPICES OF
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center align-items-center mt-3 mt-md-2">
          {logos.map((logo, i) => (
            <Col
              key={i}
              xs={12}
              sm={6}
              md={5}
              lg={4}
              className="d-flex justify-content-center mb-3 mb-sm-0"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default SupportedBy;
